const home = {
  home: {
    hero: {
      overlinePrefix: "Full-Stack Data Scientist &",
      overlineHighlight: "SaaS Builder",
      tagline: "Intelligent Digital Solutions",
      description:
        "I design and deliver intelligent digital solutions, from concept to deployment. As a Full-Stack Data Scientist with 5+ years of experience, I build robust, scalable, and product-driven AI solutions that turn complex ideas into simple, powerful, and useful products.",
      primaryCta: "Discuss your project",
      secondaryCta: "View Portfolio",
    },
    stats: {
      years: { value: "5+", label: "Years Experience" },
      endToEnd: { value: "End-to-End", label: "AI Architecture" },
      product: { value: "Product", label: "Driven Approach" },
      saas: { value: "SaaS", label: "Scalability" },
    },
    expertise: {
      titlePrefix: "Turning Expertise into",
      titleHighlight: "Value",
      subtitle:
        "A comprehensive approach combining data science, software engineering, and UX to build products that scale.",
      pillars: {
        dataScience: {
          title: "Data Science & AI",
          description:
            "Advanced modeling and predictive analytics to solve complex business problems.",
        },
        smartApis: {
          title: "Smart APIs",
          description:
            "Fast, reliable, and secure APIs to integrate AI capabilities into any workflow.",
        },
        robustArchitectures: {
          title: "Robust Architectures",
          description:
            "Scalable data pipelines and backend systems designed for high-performance products.",
        },
        cloudDeployment: {
          title: "Cloud Deployment",
          description:
            "Seamless orchestration and deployment using Docker, AWS, and modern CI/CD.",
        },
      },
      cta: "See all services & pricing models →",
    },
    activities: {
      overline: "Activities & Impact",
      titlePrefix: "Beyond the",
      titleHighlight: "Code",
      viewAll: "View All",
      learnMore: "Learn more →",
    },
  },
};

export default home;
